/** Only return to an internal application page, never an external or authentication URL. */
export function safeReturnPath(path: string | undefined): string {
  if (!path?.startsWith("/") || path.startsWith("//") || /[\\\r\n]/u.test(path)) return "/";
  const pathname = path.split(/[?#]/u)[0];
  return ["/signin", "/signout", "/auth/callback"].includes(pathname ?? "") ? "/" : path;
}
